<template>
  <!-- 组织机构  -->
  <div class="second-page-wrapper">
    <div class="second-page-wrapper-left">
      <common-slide :slideList="titleList"></common-slide>
    </div>
    <div class="second-page-wrapper-right">
      <router-view></router-view>
    </div>
  </div>
</template>
<style scoped>
.second-page-wrapper {
  width: 1230px;
  margin: 0 auto 30px;
  display: flex;
}
.second-page-wrapper-left {
  width: 310px;
  margin-right: 30px;
}
.second-page-wrapper-right {
  width: 890px;
}
</style>

<script>
import commonSlide from "./slide.vue";
export default {
  data() {
    return {
      titleList: [
        {
          title: "重大专项",
          routerName: "CooperMajor",
          showFlag: "0",
          type: "1",
          child:[]
        },
        {
          title: "国际合作",
          routerName: "interCooper",
          showFlag: "1",
          type: "2",
          child:[]
        },
        {
          title: "科研项目管理",
          routerName: "manageMent",
          showFlag: "2",
          child: [
            {
              title: "管理规定",
              type: "3"
            },
            {
              title: "完成的主要科研项目介绍",
              type: "4"
            },
            {
              title: "获奖项目清单",
              type: "5"
            },
            {
              title: "常用文件下载",
              type: "6"
            }
          ]
        }
      ]
    };
  },
  components: {
    commonSlide
  }
};
</script>




// WEBPACK FOOTER //
// src/components/views/Cooperation/index.vue